import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/search.png'


const _hoisted_1 = { class: "home-component" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "sort-bar" }
const _hoisted_4 = { class: "sort-item" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "sort-item" }
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "sort-item"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "sort-item" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "sort-item" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "sort-item" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "search-results" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "result-left" }
const _hoisted_19 = { class: "result-title" }
const _hoisted_20 = { class: "result-tags" }
const _hoisted_21 = { class: "result-price" }
const _hoisted_22 = { class: "result-right" }
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
        type: "text",
        class: "search-input",
        placeholder: "请输入搜索内容"
      }, null, 512), [
        [_vModelText, _ctx.searchQuery]
      ]),
      _createElementVNode("button", {
        class: "search-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
      }, _cache[9] || (_cache[9] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "搜索",
          class: "search-icon"
        }, null, -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRegion) = $event)),
          class: "sort-dropdown"
        }, [
          _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "区域", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: region
            }, _toDisplayString(region), 9, _hoisted_5))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedRegion]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCategory) = $event)),
          class: "sort-dropdown",
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.loadSubCategories && _ctx.loadSubCategories(...args)))
        }, [
          _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "类型", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: category
            }, _toDisplayString(category), 9, _hoisted_7))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.selectedCategory]
        ])
      ]),
      (_ctx.showSubCategory)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedSubCategory) = $event)),
              class: "sort-dropdown"
            }, [
              _cache[12] || (_cache[12] = _createElementVNode("option", { value: "" }, "子类型", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subCategories, (subCategory, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: subCategory
                }, _toDisplayString(subCategory), 9, _hoisted_9))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedSubCategory]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedPrice) = $event)),
          class: "sort-dropdown"
        }, [
          _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "价格", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceOptions, (price, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: price
            }, _toDisplayString(price), 9, _hoisted_11))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedPrice]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedMore) = $event)),
          class: "sort-dropdown"
        }, [
          _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, "更多", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreOptions, (more, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: more
            }, _toDisplayString(more), 9, _hoisted_13))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedMore]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedSort) = $event)),
          class: "sort-dropdown"
        }, [
          _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, "排序", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (sort, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: sort
            }, _toDisplayString(sort), 9, _hoisted_15))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedSort]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "result-item",
          onClick: ($event: any) => (_ctx.goToDetail(item.id))
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags, (tag, tagIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: tagIndex,
                  class: "tag"
                }, _toDisplayString(tag), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_21, _toDisplayString(item.price), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("img", {
              src: item.image,
              alt: "图片",
              class: "result-image"
            }, null, 8, _hoisted_23)
          ])
        ], 8, _hoisted_17))
      }), 128))
    ])
  ]))
}